import { Component, OnInit } from '@angular/core';
import { KeyAndValueModel } from '../../models/key-and-value.model';
import { PrivacyService } from '../../services/Privacy.service';

@Component({
    selector: 'privacy',
    templateUrl: 'privacy.component.html',
    styleUrls: ['privacy.component.scss']
})
export class PrivacyComponent implements OnInit {
  // Set Topbar Option
  Menuoption = 'center';
  Settingicon = true;
  data : KeyAndValueModel[]=[]
  constructor(private service:PrivacyService) { }

  ngOnInit(): void {
    this.service.getAll()
    .subscribe(result=>{
        this.data = result;
    })
  }
}
